import { render, staticRenderFns } from "./informedConsent.vue?vue&type=template&id=597711fc&"
import script from "./informedConsent.vue?vue&type=script&lang=js&"
export * from "./informedConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports